var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    version: "0.0.1",
    username: "taylor+taylor@haiku.ai",
    organization: "taylor",
    project: "LearnPage",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/LearnPage",
    uuid: "cda19af0-c606-42a6-8d4b-27dc22f4ae19",
    root: "https://cdn.haiku.ai/fcc9dcae-e947-46b4-93c1-3d8124b73118/2052390f1eca947b5c1e3efd709218e226c7eefe/",
    core: "4.3.5",
    title: "Arrowdash",
    type: "haiku",
    relpath: "code/arrowdash/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Arrowdash-e72cd93e18a71f9b": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 258.106,
        "sizeAbsolute.y": 291.943,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Path-60652c76dc5f9ec8": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 227.166,
        "translation.y": 30.133,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 19.423049926757812,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 26.059940338134766,
        "sizeMode.y": 1,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
          "500": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-8748b5bb49f93b29": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -198.486,
        "translation.y": -4.067
      },
      "haiku:Path-a1d869dd88b4b504": {
        d:
          "M199.203541,11.0051858 C197.857265,8.9161277 198.459409,6.13123897 200.548467,4.78496276 C202.637525,3.43868654 205.422414,4.04083025 206.76869,6.12988837 C210.508208,11.9326134 214.020659,17.6818933 217.305962,23.377857 C218.547678,25.5307076 217.809057,28.2825473 215.656206,29.5242629 C213.503356,30.7659786 210.751516,30.0273579 209.5098,27.8745073 C206.299315,22.3082606 202.863922,16.6851106 199.203541,11.0051858 Z"
      },
      "haiku:Path-f8f297ce674db868": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 221.075,
        "translation.y": 69.626,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 17.398025512695312,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 27.16429901123047,
        "sizeMode.y": 1,
        "style.zIndex": 2,
        opacity: {
          "0": { value: 0, edited: true, curve: "easeInOutQuad" },
          "167": { value: 0, edited: true, curve: "easeInOutQuad" },
          "667": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-3132f97d4984760e": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -193.414,
        "translation.y": -43.015
      },
      "haiku:Path-79395535d5f4f7c2": {
        d:
          "M193.894502,49.5368616 C192.778365,47.3163073 193.673672,44.6113844 195.894226,43.4952472 C198.114781,42.37911 200.819704,43.2744169 201.935841,45.4949711 C205.057716,51.7059403 207.89868,57.8515737 210.458504,63.9320265 C211.422818,66.2225991 210.347672,68.8612057 208.0571,69.8255192 C205.766527,70.7898327 203.12792,69.7146873 202.163607,67.4241146 C199.683188,61.5322751 196.926896,55.5698057 193.894502,49.5368616 Z"
      },
      "haiku:Path-93f1f90287353930": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 209.69,
        "translation.y": 107.903,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 14.419998168945312,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 28.258346557617188,
        "sizeMode.y": 1,
        "style.zIndex": 3,
        opacity: {
          "0": { value: 0, edited: true },
          "333": { value: 0, edited: true, curve: "easeInOutQuad" },
          "833": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-e7a5dbccf52145c1": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -183.523,
        "translation.y": -80.752
      },
      "haiku:Path-55118633ca044b3b": {
        d:
          "M183.751966,86.6662364 C182.971509,84.3066792 184.251622,81.7611947 186.61118,80.9807378 C188.970737,80.2002809 191.516221,81.4803946 192.296678,83.8399519 C194.490728,90.4732269 196.334347,97.025892 197.827003,103.497925 C198.385526,105.919635 196.875115,108.33559 194.453406,108.894113 C192.031697,109.452636 189.615741,107.942226 189.057218,105.520516 C187.627955,99.3233526 185.859715,93.0385999 183.751966,86.6662364 Z"
      },
      "haiku:Path-13bcd8713b5e7674": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 191.435,
        "translation.y": 143.347,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 10.178497314453125,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 28.96497344970703,
        "sizeMode.y": 1,
        "style.zIndex": 4,
        opacity: {
          "0": { value: 0, edited: true },
          "500": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1000": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-af8c47b2b1abf461": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -167.393,
        "translation.y": -115.851
      },
      "haiku:Path-c1c62f321466b7fc": {
        d:
          "M167.425388,120.88565 C167.1304,118.417937 168.891741,116.178326 171.359454,115.883338 C173.827167,115.58835 176.066778,117.349692 176.361766,119.817404 C177.190991,126.754267 177.594177,133.592654 177.570641,140.331765 C177.561962,142.817031 175.540219,144.824701 173.054953,144.816022 C170.569687,144.807342 168.562016,142.7856 168.570696,140.300334 C168.592936,133.932256 168.211394,127.460961 167.425388,120.88565 Z"
      },
      "haiku:Path-3cdd876549eb0f94": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 165.22900000000004,
        "translation.y": 173.343,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 13.124710083007812,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 28.575820922851562,
        "sizeMode.y": 1,
        "style.zIndex": 5,
        opacity: {
          "0": { value: 0, edited: true },
          "667": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1167": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-83a4fc5b82362c3b": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -139.716,
        "translation.y": -146.05
      },
      "haiku:Path-5dabc8970735ef05": {
        d:
          "M143.882345,149.93262 C144.223715,147.470895 146.496072,145.752007 148.957797,146.093377 C151.419522,146.434748 153.13841,148.707105 152.79704,151.16883 C151.848086,158.012027 150.430424,164.742446 148.544275,171.358562 C147.862908,173.748617 145.373029,175.133783 142.982974,174.452417 C140.592919,173.77105 139.207753,171.281171 139.88912,168.891116 C141.660009,162.679301 142.99101,156.360311 143.882345,149.93262 Z"
      },
      "haiku:Path-8a9bccbb6044d26b": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 131.885,
        "translation.y": 195.149,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 18.250587463378906,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 26.73309326171875,
        "sizeMode.y": 1,
        "style.zIndex": 6,
        opacity: {
          "0": { value: 0, edited: true },
          "833": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1333": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-d351e36ff15c214f": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -103.809,
        "translation.y": -168.786
      },
      "haiku:Path-fd54228b30350188": {
        d:
          "M113.441518,171.470284 C114.444968,169.196584 117.101623,168.166843 119.375323,169.170293 C121.649023,170.173743 122.678764,172.830398 121.675314,175.104098 C118.942415,181.296526 115.770379,187.377788 112.160207,193.347228 C110.874081,195.473846 108.107505,196.155199 105.980888,194.869072 C103.85427,193.582946 103.172917,190.81637 104.459044,188.689752 C107.871507,183.047225 110.865331,177.307621 113.441518,171.470284 Z"
      },
      "haiku:Path-9a45b9ee4bf487a8": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 94.21299999999997,
        "translation.y": 207.897,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 22.019973754882812,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 24.179794311523438,
        "sizeMode.y": 1,
        "style.zIndex": 7,
        opacity: {
          "0": { value: 0, edited: true },
          "1000": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1500": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-7e65fc0f633a7fc1": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -64.249,
        "translation.y": -182.82
      },
      "haiku:Path-d11d01bc04da8ac1": {
        d:
          "M78.208585,184.568314 C79.7283684,182.601876 82.55451,182.23979 84.5209489,183.759573 C86.4873878,185.279356 86.8494736,188.105498 85.3296902,190.071937 C81.2586172,195.339475 76.8215557,200.512595 72.019107,205.59146 C70.3115752,207.397272 67.463447,207.476944 65.6576345,205.769413 C63.851822,204.061881 63.7721497,201.213753 65.4796814,199.40794 C70.0796047,194.543258 74.3223721,189.596663 78.208585,184.568314 Z"
      },
      "haiku:Path-ae4eb18a5cbd508d": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 54.583,
        "translation.y": 212.96,
        "rotation.z": 0.646,
        "sizeAbsolute.x": 24.411561965942383,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 21.746826171875,
        "sizeMode.y": 1,
        "style.zIndex": 8,
        opacity: {
          "0": { value: 0, edited: true },
          "1167": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1667": { value: 1, edited: true },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-082c35a5f79d2de7": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -23.418,
        "translation.y": -189.108
      },
      "haiku:Path-373b05fb6f412364": {
        d:
          "M40.3351287,190.248973 C42.190096,188.594972 45.034677,188.757887 46.6886781,190.612854 C48.3426792,192.467822 48.1797639,195.312403 46.3247966,196.966404 C41.397696,201.359705 36.177006,205.677698 30.6629111,209.920643 C28.6932476,211.436245 25.8678818,211.068155 24.3522798,209.098492 C22.8366778,207.128828 23.2047674,204.303462 25.1744308,202.787861 C30.5187631,198.675544 35.5722676,194.495828 40.3351287,190.248973 Z"
      },
      "haiku:Path-11-2e2ccc326e1baecc": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 33.60900000000001,
        "translation.y": 216.593,
        "sizeAbsolute.x": 27.758468627929688,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 43.424530029296875,
        "sizeMode.y": 1,
        "style.zIndex": 9,
        opacity: {
          "0": { value: 0, edited: true },
          "1333": { value: 0, edited: true, curve: "easeInOutQuad" },
          "1833": { value: 1, edited: true, curve: "easeInOutQuad" },
          "2000": { value: 0, edited: true }
        }
      },
      "haiku:Group-2217f927b1e0b723": {
        fill: "#CD3172",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        "translation.x": -0.73,
        "translation.y": -181.881
      },
      "haiku:Path-11-c4a19a0963173cff": {
        d:
          "M26.9390993,217.408031 C28.8153728,219.037823 29.0151857,221.88005 27.3853939,223.756324 C25.7556022,225.632597 22.9133747,225.83241 21.0371012,224.202619 L2.27875024,207.908509 C0.369530245,206.250099 0.201397282,203.344544 1.90658322,201.476983 L18.4605574,183.346663 C20.1363178,181.511329 22.9826221,181.38197 24.817956,183.05773 C26.65329,184.73349 26.7826499,187.579795 25.1068895,189.415129 L11.6632489,204.138934 L26.9390993,217.408031 Z"
      },
      "haiku:Mano1-8103f561afdd73ef": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 285,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 75,
        "sizeMode.y": 1,
        "translation.x": {
          "0": { edited: true, value: -63.84, curve: "easeInOutQuad" },
          "1833": { value: -75.718, curve: "easeInOutQuad", edited: true }
        },
        "translation.y": {
          "0": { edited: true, value: 10.334, curve: "easeInOutQuad" },
          "1833": {
            value: -74.67952165692964,
            curve: "easeInOutQuad",
            edited: true
          }
        },
        "style.zIndex": 10,
        "origin.x": 0.067,
        "origin.y": -0.516,
        "scale.x": 1,
        "scale.y": 1,
        "rotation.z": {
          "0": { value: -0.235, edited: true, curve: "easeInOutQuad" },
          "1833": { value: 1.116 }
        }
      },
      "haiku:Page-1-c250526c8fa7b2d9": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-d02bbbfffec2dc50": {
        "translation.x": -39,
        "translation.y": -109
      },
      "haiku:Mano1-83a1d4013fe6c21f": {
        "translation.x": 39.438,
        "translation.y": 107
      },
      "haiku:Path-3-fb0432425f07ffff": {
        d:
          "M236.789241,17.4 L261.999163,30.6667764 C264.050493,31.7985582 264.60466,33.1983618 263.661663,34.8661872 C262.718666,36.5340126 260.6651,36.7813411 257.500967,35.6081727 C251.142111,32.2321903 245.973066,30.0244031 241.993834,28.984811 C238.014601,27.945219 233.979441,27.7483675 229.888355,28.3942566 C236.566504,30.8932916 241.392927,33.0506018 244.367623,34.8661872 C248.829668,37.5895654 249.086944,37.9298867 252.508178,42.2001082 C255.929411,46.4703297 258.132886,47.8032458 258.839914,49.6749306 C259.546943,51.5466154 259.501,53.3341586 256.855689,53.7090758 C254.210377,54.0839931 252.837531,53.0537013 250.139493,51.0308713 C247.441455,49.0080414 246.5402,46.1265428 244.873525,44.8837552 C243.762407,44.0552302 238.445934,40.1282571 228.924105,33.102836 L226.085386,34.8661872 C235.67538,44.2703523 241.38847,49.7876597 243.224655,51.4181094 C245.978933,53.8637841 248.073037,54.9730498 249.106265,55.7958232 C250.139493,56.6185966 250.433014,58.5102077 249.106265,59.2900028 C247.779516,60.0697979 246.398719,59.7297154 244.873525,59.2900028 C243.856728,58.996861 237.594016,55.191914 226.085386,47.8751616 L210.544413,29.4943636 L236.789241,17.4 Z",
        fill: "#E99631"
      },
      "haiku:Path-2-66309a96afaea21d": {
        d:
          "M0.499054691,77 L0.499054691,26.2775233 C114.966576,37.1917821 174.293004,42.6489115 178.478338,42.6489115 C182.663671,42.6489115 187.941801,40.0965589 194.312726,34.9918538 C201.417436,24.9416367 206.704685,18.6281072 210.174472,16.0512654 C211.129513,15.3420028 213.763082,15.0541298 215.143391,14.4473917 C217.555126,13.3872738 221.802879,11.9241889 227.88665,10.0581372 C229.614195,9.35271239 231.333334,9 233.044066,9 C234.754799,9 236.354532,9.35271239 237.843267,10.0581372 C240.776161,11.4297868 242.732099,12.3628127 243.711079,12.8572148 C245.179551,13.5988179 246.345073,13.988021 247.912415,15.14323 C249.479757,16.298439 250.590427,17.8037851 251.490067,18.475758 C252.389707,19.1477309 257.636531,22.9841756 258.192363,24.4673554 C258.748195,25.9505352 258.003926,28.3652562 253.897103,27.8654167 C249.790279,27.3655772 247.285671,24.5463728 245.627276,23.77343 C244.52168,23.2581348 241.92701,22.1919273 237.843267,20.5748075 C235.236812,19.9622846 232.546464,20.1362042 229.772225,21.0965662 C226.997985,22.0569282 223.491626,23.7839139 219.253148,26.2775233 C214.501076,29.8112018 213.131157,32.3921299 215.143391,34.0203076 C217.155626,35.6484853 220.359811,40.2367906 224.755948,47.7852235 C219.845196,53.0474053 215.867391,56.5298765 212.822532,58.2326372 C208.255244,60.7867783 205.570239,60.7294671 199.05721,62.1565976 C192.544181,63.5837281 186.834103,63.7221185 183.135053,63.7221185 C147.390093,65.5737946 86.5114263,69.9997551 0.499054691,77 Z",
        fill: "#FFE754"
      },
      "haiku:Pencil1-3e503f81150fc53b": {
        "translation.x": 191.978,
        "translation.y": 47.974,
        "rotation.x": 3.142,
        "rotation.z": 3.176,
        "scale.x": -1,
        "scale.y": -1,
        "scale.z": -1
      },
      "haiku:Rectangle-c30b16e4c7eb8913": {
        d:
          "M35.2955666,-17.3381608 L46.0918819,-17.3302589 L46.1502574,62.3299656 C46.1522001,64.9809317 44.0047423,67.1315391 41.3537762,67.1334818 C41.3514327,67.1334835 41.3490891,67.1334835 41.3467456,67.1334818 L40.150438,67.1326062 C37.5022171,67.1306679 35.3558931,64.9843458 35.3539525,62.3361249 L35.3192022,14.9152996 L35.2955666,-17.3381608 Z",
        fill: "#212D31",
        "translation.x": 46.078,
        "translation.y": -22.532,
        "rotation.z": 1.134
      },
      "haiku:Path-4-d2005f89a2182b83": {
        d:
          "M81.1974106,11.9255479 L76.6532951,2.16201042 L87.6935995,0.333474493 C89.9266368,-0.197511259 91.2268562,-0.0943873382 91.5942576,0.642846256 C91.961659,1.38007985 91.4835345,2.38690396 90.1598839,3.66331858 L81.1974106,11.9255479 Z",
        fill: "#CD3172"
      },
      "haiku:Path-2-Copy-4c5f971dff1d9c88": {
        d:
          "M214.623924,34.4521427 C217.642275,36.8944092 224.269833,32.627067 225.580766,31.6843698 C226.8917,30.7416726 228.553636,29.1466396 230.925357,27.6379647 C233.297079,26.1292899 233.911964,25.6286175 235.47909,24.8991905 C237.046216,24.1697634 241.465168,22.3567587 244.453848,24.205265 C247.442527,26.0537713 246.253621,30.9093753 243.941409,33.03346 C241.629197,35.1575447 240.14144,36.3123325 234.460584,39.9127207 C230.673347,42.3129795 227.265312,45.0810921 224.23648,48.2170585 C216.026314,37.5825452 212.822129,32.9942399 214.623924,34.4521427 Z",
        fill: "#FFE754"
      }
    },
    "Mano1-8103f561afdd73ef": {}
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Arrowdash-e72cd93e18a71f9b",
      "haiku-title": "Arrowdash"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Mano1-8103f561afdd73ef",
          "haiku-title": "mano1",
          "haiku-source": "designs/LearnPage.sketch.contents/slices/mano1.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-c250526c8fa7b2d9", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-d02bbbfffec2dc50",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Mano1-83a1d4013fe6c21f",
                      id: "mano1"
                    },
                    children: [
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-3-fb0432425f07ffff",
                          id: "Path-3"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-2-66309a96afaea21d",
                          id: "Path-2"
                        },
                        children: []
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "Pencil1-3e503f81150fc53b",
                          id: "pencil1"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Rectangle-c30b16e4c7eb8913",
                              id: "Rectangle"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "Path-4-d2005f89a2182b83",
                              id: "Path-4"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-2-Copy-4c5f971dff1d9c88",
                          id: "Path-2-Copy"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-11-2e2ccc326e1baecc",
          "haiku-title": "Path-11",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path-11"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-2217f927b1e0b723" },
            children: [
              {
                elementName: "path",
                attributes: {
                  "haiku-id": "Path-11-c4a19a0963173cff",
                  id: "Path-11"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-ae4eb18a5cbd508d",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-082c35a5f79d2de7" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-373b05fb6f412364", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-9a45b9ee4bf487a8",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-7e65fc0f633a7fc1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-d11d01bc04da8ac1", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-8a9bccbb6044d26b",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-d351e36ff15c214f" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-fd54228b30350188", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-3cdd876549eb0f94",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-83a4fc5b82362c3b" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-5dabc8970735ef05", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-13bcd8713b5e7674",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-af8c47b2b1abf461" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-c1c62f321466b7fc", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-93f1f90287353930",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-e7a5dbccf52145c1" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-55118633ca044b3b", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-f8f297ce674db868",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-3132f97d4984760e" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-79395535d5f4f7c2", id: "Path" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Path-60652c76dc5f9ec8",
          "haiku-title": "Path",
          "haiku-source":
            "designs/LearnPage.sketch.contents/slices/arrow.svg#Path"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-8748b5bb49f93b29" },
            children: [
              {
                elementName: "path",
                attributes: { "haiku-id": "Path-a1d869dd88b4b504", id: "Path" },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-learnpage/code/arrowdash/code.js
// module id = 529
// module chunks = 127651196306611